import { render } from "./ComplimentaryTicketDetailsPage.vue?vue&type=template&id=38c3494a&scoped=true"
import script from "./ComplimentaryTicketDetailsPage.vue?vue&type=script&lang=js"
export * from "./ComplimentaryTicketDetailsPage.vue?vue&type=script&lang=js"

import "./ComplimentaryTicketDetailsPage.vue?vue&type=style&index=0&id=38c3494a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38c3494a"]])

export default __exports__